import { inject, Injectable } from '@angular/core';
import { TpaGroupSortService } from './tpa-group-sort.service';

@Injectable({
  providedIn: 'root',
})
export class TpaDetailSortService {
  private tpaGroupSortService = inject(TpaGroupSortService);

  constructor() {}

  sortCensusLines<
    T extends { isActive: boolean; dateJoined: string; isDraft?: string; policyStartDate: string },
  >(censusLines: T[]): T[] {
    if (!censusLines?.length) return [];

    return [...censusLines].sort((a, b) => {
      // Primary sort: by dateJoined descending (most recent at top, oldest at bottom)
      if (a.dateJoined && b.dateJoined) {
        const dateComparison = b.dateJoined.localeCompare(a.dateJoined);
        if (dateComparison !== 0) {
          return dateComparison;
        }
      }

      // Secondary sort: by policyStartDate descending if dateJoined is the same
      if (a.policyStartDate && b.policyStartDate) {
        return b.policyStartDate.localeCompare(a.policyStartDate);
      }

      return 0;
    });
  }
}
